<template>
    <div class="com-record-choose-item" :class="className" @click.stop="clickItem">
        <i class="iconfont layout-gl-icon-s" v-bind:class="{'icon-disabled' : recordData.selectDisabled, 'icon-unselected' : !recordData.selected, 'icon-selected' : recordData.selected}"></i>
        <record-item
            v-bind:recordData="recordData">
        </record-item>
    </div>
</template>

<script>
import RecordItem from './RecordItem.vue'
export default {
    name: 'RecordChooseItem',
    components: { RecordItem },
    props: {
        className: {
            type: String,
            default() { return '' }
        },
        recordData: {
            type: Object,
            default () { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return undefined }
        }
    },
    methods: {
        clickItem() {
            // 更新勾选状态
            if(!this.recordData.selectDisabled) {
                this.recordData.selected = !this.recordData.selected;
            }

            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(this.recordData);
            }
        }
    }
}
</script>